
import { initializeApp } from "firebase/app";
import { getAuth } from 'firebase/auth';
import "firebase/firestore";
import { getFirestore } from "firebase/firestore";
import { getStorage } from 'firebase/storage'
import "firebase/storage";



const firebaseConfig = {
    apiKey: "AIzaSyAQ5M6T-D_NR6QkxDEDf20Ptf_mbgHbqK8",
  authDomain: "unicorn-aerocity.firebaseapp.com",
  projectId: "unicorn-aerocity",
  storageBucket: "unicorn-aerocity.firebasestorage.app",
  messagingSenderId: "894608528407",
  appId: "1:894608528407:web:08523d78d8c3b171feb852",
  measurementId: "G-JV3SKQYG3X"
 
};
//init firebase app
const app = initializeApp(firebaseConfig);
export const storage = getStorage(app);
export const auth = getAuth(app);
export const db = getFirestore(app);




export default app;